<div
  class="search-operations-container"
  [class.mobile]="platform === platformEnum.mobile"
>
  <ion-button
    data-cy="compare-button"
    class="compare-button"
    [ngClass]="
      selection === SelectionType.CompareProducts
        ? 'usf-fill-green-button'
        : 'usf-green-link-button'
    "
    (click)="handleSelectionTypeChange(SelectionType.CompareProducts)"
  >
    {{
      'i18n.newSearch.searchResultOperationButtons.compareSelections'
        | translate
    }}
  </ion-button>

  <ng-container *ngIf="showAddIngredient">
    <div id="add-ingredient-separator" class="line-separator"></div>
    <ion-button
      class="operations-button"
      [ngClass]="
        selection === SelectionType.AddIngredient
          ? 'usf-fill-green-button'
          : 'usf-green-link-button'
      "
      (click)="handleSelectionTypeChange(SelectionType.AddIngredient)"
    >
      <ion-icon name="add-outline"></ion-icon>
      {{
        'i18n.newSearch.searchResultOperationButtons.addIngredient' | translate
      }}
    </ion-button>
  </ng-container>

  <ng-container *ngIf="!(isGuestUser || showAddIngredient)">
    <div
      id="add-to-list-separator"
      class="line-separator"
      *ngIf="showAddToList"
    ></div>

    <ion-button
      data-cy="add-to-list-button"
      *ngIf="showAddToList"
      class="add-to-list-button"
      [ngClass]="
        selection === SelectionType.AddToList
          ? 'usf-fill-green-button'
          : 'usf-green-link-button'
      "
      (click)="handleSelectionTypeChange(SelectionType.AddToList)"
    >
      <ion-icon name="add-outline"></ion-icon>
      {{ 'i18n.newSearch.searchResultOperationButtons.addToList' | translate }}
    </ion-button>

    <div
      id="add-to-inventory-separator"
      class="line-separator"
      *ngIf="showInventory"
    ></div>

    <ion-button
      data-cy="add-to-inventory-button"
      *ngIf="showInventory"
      class="add-to-inventory-button"
      [ngClass]="
        selection === SelectionType.AddToInventory
          ? 'usf-fill-green-button'
          : 'usf-green-link-button'
      "
      (click)="handleSelectionTypeChange(SelectionType.AddToInventory)"
    >
      <ion-icon name="add-outline"></ion-icon>
      {{
        'i18n.newSearch.searchResultOperationButtons.addToInventory' | translate
      }}
    </ion-button>
  </ng-container>
</div>
